import { Stack } from "@mui/material";

import { HourlyPayLabel } from "../../Pay/HourlyPayLabel";
import { TotalPayLabel } from "../../Pay/TotalPayLabel";
import { InstantPayIndicator } from "../../Shift/BottomSheet/OnCallShift/InstantPayIndicator";

export function CombinedPayLabels({
  hourlyPay,
  totalPay,
  isInstantPay,
  isLoading,
}: {
  hourlyPay?: string;
  totalPay?: string;
  isInstantPay?: boolean;
  isLoading?: boolean;
}) {
  return (
    <>
      <HourlyPayLabel size="large" hourlyPay={hourlyPay} isLoading={isLoading} />
      <Stack direction="row" spacing={2} alignItems="center">
        <TotalPayLabel totalPay={totalPay} isLoading={isLoading} />
        {isInstantPay && <InstantPayIndicator />}
      </Stack>
    </>
  );
}
